import PostEventTypes from './HostedPaymentIframePostEventTypes';


/**
 * @typedef HostedPaymentIframeCallbacks
 * @property {function} [onReady]
 * @property {function} [onPaymentProcessed]
 * @property {function} [scrollToTop]
 */


/**
 * @param {HostedPaymentIframeCallbacks} options
 */
const mergeCallbacks = (options = {}) => {
  const noop = () => {};

  /** @type {HostedPaymentIframeCallbacks} */
  const defaults = {
    onReady: noop,
    onPaymentProcessed: noop,
    scrollToTop: noop,
  };

  return Object.assign({}, defaults, options);
};

class HostedPaymentIframe {
  isPaymentProcessed = false;

  /**
   * @param {string} src
   * @param {string} origin
   * @param {HostedPaymentIframeCallbacks} callbacks
   */
  constructor(src, origin, callbacks) {
    this.src = src;
    this.origin = origin;

    this.callbacks = mergeCallbacks(callbacks);

    this.$el = document.createElement('iframe');
    this.$el.tabIndex = 0;
  }

  load = () => {
    this.$el.src = this.src;

    this.startListening();
  }

  /**
   * @param {MessageEvent} event
   */
  testShouldHandleMessageEvent({ origin, source }) {
    if (origin !== this.origin) {
      return false;
    }

    if (source !== this.$el.contentWindow) {
      return false;
    }

    return true;
  }

  /**
   * @param {MessageEvent} event
   */
  handleMessage = (event) => {
    if (!this.testShouldHandleMessageEvent(event)) {
      return;
    }

    const { data } = event;

    switch (data.type) {
      case PostEventTypes.Loaded:
        this.callbacks.onReady();
        break;

      case PostEventTypes.Resize:
        this.$el.style.height = `${data.height}px`;
        this.$el.style.minHeight = 'auto';
        break;

      case PostEventTypes.ScrollTop:
        this.callbacks.scrollToTop();
        break;

      case PostEventTypes.Finished:
        this.isPaymentProcessed = true;
        this.callbacks.onPaymentProcessed();
        break;

      default:
        break;
    }
  }

  startListening() {
    window.addEventListener('message', this.handleMessage);
  }

  stopListening = () => {
    window.removeEventListener('message', this.handleMessage);
  }
}


/**
 * @param {string} src
 * @param {string} origin
 * @param {HostedPaymentIframeCallbacks} callbacks
 */
const create = (src, origin, callbacks) => {
  const instance = new HostedPaymentIframe(src, origin, callbacks);

  return {
    $el: instance.$el,
    load: instance.load,
    stopListening: instance.stopListening,
    getIsPaymentProcessed: () => instance.isPaymentProcessed,
  };
};


export default {
  create,
};



// WEBPACK FOOTER //
// ./src/onePageGiving/hostedPayment/HostedPaymentIframe.js